import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { getLocationByLocationId } from 'src/common/Scraper';
import { LocationApiResponse } from '../types';

const QUERY_KEY = 'getLocationInfoByLocationId';

interface IUseGetLocationInfoByLocationIdProps {
  locationId?: string;
}

export const useGetLocationInfoByLocationId = ({
  locationId
}: IUseGetLocationInfoByLocationIdProps): UseQueryResult<
  AxiosResponse<LocationApiResponse>,
  AxiosError
> => {
  return useQuery<AxiosResponse<LocationApiResponse>, AxiosError>({
    queryKey: [QUERY_KEY, locationId],
    queryFn: () =>
      getLocationByLocationId(locationId!) as Promise<
        AxiosResponse<LocationApiResponse>
      >,
    enabled: false
  });
};
